import Typography from "@mui/material/Typography"
import {Divider} from "@mui/material"
import Button from "@mui/material/Button"
import Paper from "@mui/material/Paper"
import React, {useEffect, useState} from "react"
import {Link} from "react-router-dom"
import {getFieldErrorParams, getIconByServiceType} from "../../utils"
import {BACKEND_URL} from "../../data/config";
import Alert from "@mui/material/Alert";
import CheckIcon from '@mui/icons-material/Check'
import CancelIcon from '@mui/icons-material/Cancel';
import Grid from "@mui/material/Grid";
import {TextValidator, ValidatorForm} from "react-material-ui-form-validator";
import InputAdornment from "@mui/material/InputAdornment";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import {baseStyles} from "../../assets/css/styles";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import DiscountOutlinedIcon from '@mui/icons-material/DiscountOutlined';
import {useGlobalContext} from "../../contexts/global_context";
import {useGoogleReCaptcha} from "react-google-recaptcha-v3";
import ConfirmDialog from "../admin/dialog/ConfirmDialog";


const OrderSummary = ({order, setOrder}) => {
  let [orderInfo, setOrderInfo] = useState(JSON.parse(localStorage.getItem('order_info')) || {})
  let {sendAjax, setIsSendingAjax, isSendingAjax, sendingAjaxUrls, setSendingAjaxUrls} = useGlobalContext()
  const {executeRecaptcha} = useGoogleReCaptcha()
  const [fieldErrors, setFieldErrors] = useState({})
  const [isOpenRemoveDialog, setIsOpenRemoveDialog] = useState(false)
  const applyUrl = `${BACKEND_URL}/api/v1/commerce/orders/apply-discount/${order.uid}/`
  const deleteUrl = `${BACKEND_URL}/api/v1/commerce/orders/delete-discount/${order.uid}/`
  const [showDiscount, setShowDiscount] = useState(false)
  
  useEffect(() => {
    if (parseFloat(order.discount_price) || order.discount_code) {
      setShowDiscount(true)
    }
  }, [order.discount_price, order.discount_code])

  const applyDiscount = () => {
    if (!executeRecaptcha) {
      return
    }

    setSendingAjaxUrls([
      ...sendingAjaxUrls,
      applyUrl,
    ])

    executeRecaptcha('APPLY_DISCOUNT').then(gr => {
      sendAjax({
        url: applyUrl,
        method: 'post',
        data: {
          code: order.discount_code,
          gr: gr,
        },
        successMessage: '',
      }).then(r => {
        if (r?.data?.status_code === 200) {
          setOrder(r.data.data)
          setFieldErrors({})
        } else if (r?.data?.status_code === 400) {
          setFieldErrors(r?.data?.data || {})
        }
      })
    })
  }

  const removeDiscount = () => {
    sendAjax({
      url: deleteUrl,
      method: 'post',
      data: {},
      successMessage: '',
    }).then(r => {
      if (r?.data?.status_code === 200) {
        setOrder(r.data.data)
        setIsOpenRemoveDialog(false)
      }
    })
  }

  return (
    <div className={'order-summary-container'}>
      <ConfirmDialog
        message={'Remove discount from this order?'}
        confirmBtnText={'Remove'}
        onConfirm={removeDiscount}
        onClose={() => setIsOpenRemoveDialog(false)}
        isOpen={isOpenRemoveDialog}
        zIndex={2000}
        loading={sendingAjaxUrls.includes(deleteUrl)}
      />
      <Paper className={'enter-details-container'} elevation={5}>
        <div className={'enter-details-header'}>
          <Typography variant="h5" component="h1">
            Order Summary
          </Typography>
        </div>

        <Divider/>

        <div className={'order-summary-account-info'}>
          <img
            className={'order-summary-account-info-avatar'}
            src={`${BACKEND_URL}/api/v1/socials/url-router/?url=${encodeURIComponent(orderInfo.profile_pic)}`}
            alt={'avatar'}
          />

          <div className={'order-summary-account-info-user'}>
            <b style={{display: 'block', margin: '7px 7px 0 7px'}}>
              {orderInfo.link_title}
            </b>

            <Button
              component={Link}
              to={`/packages/${order.package_slug}`}
              variant="text"
            >
              Change
            </Button>
          </div>
        </div>

        <Divider/>

        <div className={'order-summary-order-info'}>
          <div className={'order-summary-order-info-icon'}>
            {getIconByServiceType(10)}
          </div>

          <div className={'order-summary-order-info-title'}>
            <b style={{display: 'block'}}>
              {order.title}
            </b>

            {order.num_posts &&
            [10, 20].includes(order.social) &&
            order.service_type_quantities ?
              order.service_type_quantities.map(item => {
                return (
                  <div style={{marginTop: '7px'}} key={item.service_type}>
                    {Math.floor(item.display_quantity / order.num_posts)}
                    &nbsp;
                    {item.service_type_display} / {order.num_posts} Post(s)
                  </div>
                )
              })
              :
              <></>
            }
          </div>
        </div>

        <Divider/>

        <div className={'order-summary-price'}>
          <Grid container spacing={0}>

            {parseFloat(order.discount_price) && order.discount_message_body ? (
              <Grid item xs={12} sm={12} md={12}>
                <Alert
                  icon={order.discount_message_emoji || '🎁'}
                  severity="success"
                  sx={{marginBottom: 1, marginTop: 1}}
                >
                  <Typography variant="body1" gutterBottom>
                    {order.discount_message_body}
                  </Typography>
                  <Typography variant="body2" gutterBottom sx={{color: '#000000'}}>
                    You saved ${order.discount_price}.
                  </Typography>
                </Alert>
              </Grid>
            ) : ''}

            <Grid item xs={12} sm={12} md={12}>
              {!showDiscount ? (
                <Button
                  variant="text"
                  size="small"
                  startIcon={<DiscountOutlinedIcon color={'secondary'} />}
                  onClick={() => setShowDiscount(true)}
                  sx={{ paddingLeft: 0, paddingBottom: 0 }}
                >
                  Use discount code
                </Button>
              ) : (
                <Box
                  component={ValidatorForm}
                  onSubmit={applyDiscount}
                  sx={{
                    paddingTop: '10px',
                    paddingBottom: '10px',
                    paddingRight: 0,
                  }}
                >

                  <Grid container spacing={1}>
                    <Grid item xs={9} sm={9} md={9}>
                      <TextValidator
                        label={'Discount Code'}
                        placeholder={parseFloat(order.discount_price) ? 'An offer is active.' : 'Enter discount code'}
                        name={'code'}
                        variant={'outlined'}
                        disabled={Boolean(parseFloat(order.discount_price))}
                        value={order.discount_code || ''}
                        onChange={(e) => {
                          setOrder(order => ({
                            ...order,
                            discount_code: e.target.value,
                          }))
                          setFieldErrors({})
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <DiscountOutlinedIcon color={'secondary'}/>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth={true}
                        validators={['required']}
                        errorMessages={['This field is required']}
                        {...getFieldErrorParams(fieldErrors, 'code')}
                      />
                    </Grid>

                    <Grid item xs={3} sm={3} md={3}>
                      {parseFloat(order.discount_price) ?
                        <LoadingButton
                          sx={{
                            padding: '5px 0px 5px 0px',
                          }}
                          color={'error'}
                          size={'small'}
                          fullWidth={true}
                          variant="outlined"
                          onClick={() => setIsOpenRemoveDialog(true)}
                        >
                          Remove Discount
                        </LoadingButton> :

                        <LoadingButton
                          sx={{
                            padding: '15px 0px 14px 0px',
                          }}
                          type={'submit'}
                          color={'primary'}
                          size={'large'}
                          fullWidth={true}
                          variant="outlined"
                          loading={sendingAjaxUrls.includes(applyUrl)}
                          disabled={!executeRecaptcha}
                        >
                          Apply
                        </LoadingButton>}
                    </Grid>
                  </Grid>
                </Box>
              )}
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <Typography variant="h6" gutterBottom component="span" sx={{float: 'left'}}>
                Total to Pay
              </Typography>
            </Grid>

            <Grid item xs={6} sm={6} md={6}>
              <Typography variant="h6" gutterBottom component="span" sx={{float: 'right'}}>
                ${order.price} USD
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12} md={12}>
              <Divider sx={{mb: 2, mt: '2px'}}/>
            </Grid>

          </Grid>

        </div>
      </Paper>
    </div>
  )
}

export default OrderSummary
